<template>
  <div>
    <v-data-table
      :loading="loadingTable"
      disable-pagination
      disable-sort
      hide-default-footer
      :headers="headers"
      :items="channels"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Produção Por Canal</v-toolbar-title>
          <v-divider
            class="mx-4"
            inset
            vertical
          />
          <v-btn
            color="primary"
            outlined
            icon
            large
            :loading="loadingExport"
            :disabled="loadingExport"
            @click="sendExportExcel"
          >
            <v-icon>{{ icons.mdiFileExcelOutline }}</v-icon>
          </v-btn>
          <v-btn
            class="ml-2"
            rounded
            outlined
            large
            color="primary"
            @click="dialogFilter = true"
          >
            <v-icon>{{ icons.mdiFilter }}</v-icon>
            Filtros
          </v-btn>
          <v-chip
            v-if="filter.checkout_date_start && filter.checkout_date_end"
            class="ml-2"
            color="primary"
            outlined
          >
            {{ formatDate(filter.checkout_date_start) }} a {{ formatDate(filter.checkout_date_end) }}
          </v-chip>
          <v-text-field
            v-model="filter.search"
            :append-icon="icons.mdiMagnify"
            class="mt-6 ml-2"
            dense
            rounded
            outlined
            label="Pesquisar canal"
            @click:append="initialize"
            @keyup.enter="initialize"
          />
        </v-toolbar>
      </template>

      <template v-slot:item.sumDiary="{ item }">
        {{ formatMoney(item.sumDiary) }}
      </template>
      <template v-slot:item.mediaDiary="{ item }">
        {{ formatMoney(item.mediaDiary) }}
      </template>

      <template v-slot:foot>
        <tr style="height:44px; background:#fafafa">
          <td
            colspan="2"
            style="border-top:solid 1px #e4e3e6;padding-left:16px"
          >
            TOTAL DE CANAIS: <b>{{ channels.length }}</b>
          </td>
          <td
            colspan="3"
            style="border-top:solid 1px #e4e3e6;padding-left:16px"
          >
            TOTAL ROOM-NIGHTS: <b>{{ totalRoomNight }}</b>
          </td>
        </tr>
        <tr style="height:44px; background:#fafafa">
          <td
            colspan="2"
            style="border-top:solid 1px #e4e3e6;padding-left:16px"
          >
            TOTAL DIÁRIAS (R$): <b>{{ formatMoney(totalDiary) }}</b>
          </td>
          <td
            colspan="3"
            style="border-top:solid 1px #e4e3e6;padding-left:16px"
          >
            TOTAL DIÁRIA MÉDIA (R$): <b>{{ formatMoney(averageDiary) }}</b>
          </td>
        </tr>
      </template>

      <template v-slot:no-data>
        <NoDataTable />
      </template>
      <template v-slot:loading>
        Carregando...
      </template>
    </v-data-table>

    <v-dialog
      v-model="dialogFilter"
      width="700"
    >
      <v-card>
        <BarTitleDialog
          title="FILTROS"
          @close="dialogFilter = false"
        />
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="filter.checkout_date_start"
                outlined
                type="date"
                label="Data Checkout Inicial"
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="filter.checkout_date_end"
                outlined
                type="date"
                label="Data Checkout Final"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn
            text
            color="error"
            @click="clearFilter"
          >
            Limpar filtros
          </v-btn>
          <v-spacer />
          <v-btn
            text
            @click="dialogFilter = false"
          >
            Fechar
          </v-btn>
          <v-btn
            color="primary"
            @click="applyFilter"
          >
            Aplicar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mdiFileExcelOutline, mdiFilter, mdiMagnify } from '@mdi/js'
import { mapActions } from 'vuex'
import BarTitleDialog from '@/components/BarTitleDialog.vue'
import NoDataTable from '@/components/NoDataTable.vue'

function currentMonthRange() {
  const now = new Date()
  const start = new Date(now.getFullYear(), now.getMonth(), 1)
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 0)
  const format = date => date.toISOString().substring(0, 10)

  return { checkout_date_start: format(start), checkout_date_end: format(end), search: '' }
}

export default {
  components: { BarTitleDialog, NoDataTable },
  data: () => ({
    channels: [],
    filter: currentMonthRange(),
    dialogFilter: false,
    loadingTable: false,
    loadingExport: false,
    headers: [
      { text: 'ID', value: 'id' },
      { text: 'CANAL', value: 'origin' },
      { text: 'ROOM-NIGHTS', value: 'diary', align: 'center' },
      { text: 'RECEITA DE HOSPEDAGEM', value: 'sumDiary', align: 'right' },
      { text: 'DIÁRIA MÉDIA', value: 'mediaDiary', align: 'right' },
    ],
    icons: { mdiFileExcelOutline, mdiFilter, mdiMagnify },
  }),
  computed: {
    totalRoomNight() {
      return this.channels.reduce((total, item) => total + Number(item.diary), 0)
    },
    totalDiary() {
      return this.channels.reduce((total, item) => total + Number(item.sumDiary), 0)
    },
    averageDiary() {
      return this.totalRoomNight ? this.totalDiary / this.totalRoomNight : 0
    },
  },
  created() {
    this.initialize()
  },
  methods: {
    ...mapActions('production_by_channel', ['getAll', 'exportExcel']),
    initialize() {
      this.loadingTable = true
      this.getAll(this.filter)
        .then(response => { this.channels = response.data })
        .finally(() => { this.loadingTable = false })
    },
    applyFilter() {
      this.initialize()
      this.dialogFilter = false
    },
    clearFilter() {
      this.filter = { checkout_date_start: '', checkout_date_end: '', search: '' }
    },
    sendExportExcel() {
      this.loadingExport = true
      this.exportExcel(this.filter)
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')
          fileLink.href = fileURL
          fileLink.setAttribute('download', 'relatorio-producao-por-canal.xlsx')
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .finally(() => { this.loadingExport = false })
    },
    formatDate(date) {
      return new Date(`${date}T00:00:00`).toLocaleDateString('pt-BR')
    },
    formatMoney(value) {
      return Number(value || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
  },
}
</script>
